//src/authFetch.js
import { keycloak, ensureFreshToken } from './auth/keycloak';
import { tbUrl } from './api/api';

export async function authFetchProxy(path, opts = {}) {
  // path like '/aggregator/' or '/jobmanager/groups'
  await ensureFreshToken();
  const headers = new Headers(opts.headers || {});
  if (keycloak.token) headers.set('Authorization', `Bearer ${keycloak.token}`);
  return fetch(tbUrl(path), { ...opts, headers });
}
